export default "__VITE_ASSET__BqQtjWuB__"